export default __webpack_public_path__ + "static/media/granville22.26f9071c.jpg";